import TaskListService from '../../../modules/taskList/taskListService'
import Errors from '../../../modules/shared/error/errors'
import Message from '../../../view/shared/message'
import { push } from 'redux-first-history'
import { i18n } from '../../../i18n'

const prefix = 'TASKLIST_FORM'

const taskListFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: taskListFormActions.INIT_STARTED,
      })

      let record = {}

      const isEdit = Boolean(id)

      if (isEdit) {
        record = await TaskListService.find(id)
      }

      dispatch({
        type: taskListFormActions.INIT_SUCCESS,
        payload: record,
      })
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: taskListFormActions.INIT_ERROR,
      })

      dispatch(push('/task-list'))
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: taskListFormActions.CREATE_STARTED,
      })

      await TaskListService.create(values)

      dispatch({
        type: taskListFormActions.CREATE_SUCCESS,
      })

      Message.success(
        i18n('entities.taskList.create.success'),
      )

      dispatch(push('/task-list'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: taskListFormActions.CREATE_ERROR,
      })
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: taskListFormActions.UPDATE_STARTED,
      })

      await TaskListService.update(id, values)

      dispatch({
        type: taskListFormActions.UPDATE_SUCCESS,
      })

      Message.success(
        i18n('entities.taskList.update.success'),
      )

      dispatch(push('/task-list'))
    } catch (error) {
      Errors.handle(error)

      dispatch({
        type: taskListFormActions.UPDATE_ERROR,
      })
    }
  },
}

export default taskListFormActions
